import { Card, CardContent, Grid, Typography } from "@material-ui/core";
import moment from "moment";
import React from "react";
import { Delivery } from "../types";

interface PickupInfoProps {
  record?: Delivery;
}

const PickupInfo: React.FC<PickupInfoProps> = ({ record }) => {
  // Don't render if no pickup data or not picked
  if (!record || !record.picked_time) {
    return null;
  }

  const pickupTime = record.picked_time
    ? moment(record.picked_time)
        .tz("Asia/Singapore")
        .format("DD MMMM yyyy - hh:mm A")
    : "";
  const pickupNote = (record as any).pickup_note || "No note provided";
  const pickupMedias = (record as any).pickup_medias || [];

  return (
    <Card variant="outlined" style={{ margin: "12px 0" }}>
      <CardContent style={{ padding: "12px 16px" }}>
        <Typography
          variant="h6"
          gutterBottom
          color="primary"
          style={{ fontSize: "1rem", marginBottom: "8px" }}
        >
          Pickup Information
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <Typography variant="caption" color="textSecondary" display="block">
              Picked At
            </Typography>
            <Typography variant="body2">{pickupTime}</Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="caption" color="textSecondary" display="block">
              Pickup Note
            </Typography>
            <Typography variant="body2">{pickupNote}</Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="caption" color="textSecondary" display="block">
              Attachments ({pickupMedias.length})
            </Typography>
            {pickupMedias.length > 0 ? (
              <ul style={{ margin: 0, paddingLeft: "16px" }}>
                {pickupMedias.map((media: any, counter: number) => (
                  <li key={counter}>
                    <a
                      href={media.url}
                      target="_blank"
                      rel="noreferrer"
                      style={{ fontSize: "0.875rem" }}
                    >{`Attachment ${counter + 1}`}</a>
                  </li>
                ))}
              </ul>
            ) : (
              <Typography variant="body2" color="textSecondary">
                No attachments
              </Typography>
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default PickupInfo;
